import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Search, Btn, Badge, StatusBadge, Modal, Pager, Skeleton, Empty, ErrorBox, Avatar, Field, Toggle, num, money, fdt, ago, exportCsv } from "../ui";
import { absUrl, siteLink } from "../api";

/* Contact page → "Talk to the founder" paid bookings (WhatsApp chat / phone call) */
const TAKE = 30;
const TABS = [["PENDING", "Pending"], ["APPROVED", "Confirmed"], ["DONE", "हो गई"], ["REJECTED", "Rejected"], ["ALL", "सभी"]];
const SLOT = { morning: "सुबह 10–1", afternoon: "दोपहर 2–5", evening: "शाम 6–9" };

// "now + 1 day at 11:00" in the value a datetime-local box needs
const localIn = (iso) => {
  const d = iso ? new Date(iso) : new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
const suggest = (a) => {
  const h = a.prefSlot === "afternoon" ? 15 : a.prefSlot === "evening" ? 19 : 11;
  const day = a.prefDate ? new Date(a.prefDate + "T00:00:00") : new Date(Date.now() + 86400000);
  day.setHours(h, 0, 0, 0);
  return localIn(day.toISOString());
};

function ApproveModal({ a, onClose, onDone }) {
  const { run } = useWA();
  const [when, setWhen] = useState(suggest(a));
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await run("apptReview", { id: a.id, decision: "approve", scheduledAt: when ? new Date(when).toISOString() : "", note }, "Booking confirm हो गई, user को message गया");
      onDone();
    } catch (e) {
      /* toast */
    }
    setBusy(false);
  };
  return (
    <Modal open onClose={onClose} title="Booking confirm करें" width={480}
      footer={<><Btn onClick={onClose}>रद्द करें</Btn><Btn variant="success" icon="fa-solid fa-check" loading={busy} onClick={save}>Confirm करें</Btn></>}>
      <p className="text-sm mb-3">पहले बैंक में <b className="font-mono">UTR {a.utr}</b> और <b>{money(a.amount)}</b> मिला लें।</p>
      <Field label="बात करने का समय" hint="User को यही समय दिखेगा। खाली छोड़ें = 'founder जल्द contact करेंगे'">
        <div className="flex gap-2">
          <input type="datetime-local" className="wa-input" value={when} onChange={(e) => setWhen(e.target.value)} />
          {when && <Btn size="sm" onClick={() => setWhen("")}>खाली</Btn>}
        </div>
      </Field>
      <Field label="User के लिए message (optional)" className="mt-3">
        <textarea rows={3} className="wa-input" value={note} maxLength={300} placeholder="जैसे: मैं आपको WhatsApp पर message करूँगा, तैयार रहें।" onChange={(e) => setNote(e.target.value)} />
      </Field>
    </Modal>
  );
}

function SettingsCard() {
  const { api, run, toast } = useWA();
  const [bk, setBk] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api("settingsGet").then((r) => setBk(r.settings.booking)).catch(() => null);
  }, [api]);
  if (!bk) return null;
  const up = (k, v) => setBk({ ...bk, [k]: v });
  const save = async () => {
    setBusy(true);
    try {
      await run("settingsSave", { section: "booking", value: { ...bk, whatsappRate: Number(bk.whatsappRate), callRate: Number(bk.callRate), minMinutes: Number(bk.minMinutes), maxMinutes: Number(bk.maxMinutes), step: Number(bk.step) } });
      toast("Booking settings save हो गईं");
    } catch (e) {
      /* toast */
    }
    setBusy(false);
  };
  return (
    <Card className="mb-5" title="Booking settings" icon="fa-solid fa-sliders" subtitle="Contact page पर दिखने वाली कीमत और minutes" actions={<Btn variant="primary" size="sm" icon="fa-solid fa-floppy-disk" loading={busy} onClick={save}>Save</Btn>}>
      <Toggle label="Booking चालू" desc="बंद करने पर Contact page पर 'Bookings are paused' दिखेगा" checked={!!bk.enabled} onChange={(v) => up("enabled", v)} />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mt-2">
        <Field label="WhatsApp ₹ / मिनट"><input type="number" min="1" className="wa-input" value={bk.whatsappRate} onChange={(e) => up("whatsappRate", e.target.value)} /></Field>
        <Field label="Call ₹ / मिनट"><input type="number" min="1" className="wa-input" value={bk.callRate} onChange={(e) => up("callRate", e.target.value)} /></Field>
        <Field label="कम से कम मिनट"><input type="number" min="1" className="wa-input" value={bk.minMinutes} onChange={(e) => up("minMinutes", e.target.value)} /></Field>
        <Field label="ज़्यादा से ज़्यादा मिनट"><input type="number" min="1" className="wa-input" value={bk.maxMinutes} onChange={(e) => up("maxMinutes", e.target.value)} /></Field>
        <Field label="Slider का कदम (मिनट)"><input type="number" min="1" className="wa-input" value={bk.step} onChange={(e) => up("step", e.target.value)} /></Field>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mt-3">
        <Field label="Founder का नाम"><input className="wa-input" value={bk.founderName} onChange={(e) => up("founderName", e.target.value)} /></Field>
        <Field label="पद (title)"><input className="wa-input" value={bk.founderTitle} onChange={(e) => up("founderTitle", e.target.value)} /></Field>
        <Field label="Continue button के नीचे लाइन (optional)"><input className="wa-input" value={bk.note} placeholder="जैसे: रविवार को बंद" onChange={(e) => up("note", e.target.value)} /></Field>
      </div>
    </Card>
  );
}

export default function Appointments() {
  const { run, confirm, prompt } = useWA();
  const [status, setStatus] = useState("PENDING");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const [shot, setShot] = useState(null);
  const [approving, setApproving] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [status, dq]);
  const { data, loading, error, reload } = useLoad("appointments", { status, q: dq, take: TAKE, skip }, [status, dq, skip]);
  const items = (data && data.items) || [];

  const act = async (params, msg, ask) => {
    if (ask && !(await confirm(ask))) return;
    try {
      await run("apptReview", params, msg);
      reload();
    } catch (e) {
      /* toast */
    }
  };
  const reject = async (a) => {
    const note = await prompt({ title: "Reject का कारण", text: "यह user को दिखेगा।", defaultValue: "Payment नहीं मिला" });
    if (note !== null) act({ id: a.id, decision: "reject", note }, "Booking reject हो गई");
  };
  const wa = (a) => {
    const n = a.phone.replace(/\D/g, "");
    const num91 = n.length === 10 ? "91" + n : n;
    const when = a.scheduledAt ? ` ${fdt(a.scheduledAt)} पर` : "";
    return `https://wa.me/${num91}?text=${encodeURIComponent(`Hi ${a.name}, मैं YCNP से Vishal Kumar. आपकी ${a.minutes} मिनट की ${a.mode === "CALL" ? "call" : "WhatsApp chat"} booking confirm है${when}.`)}`;
  };

  return (
    <div>
      <PageHead icon="fa-solid fa-calendar-check" title="Appointments" subtitle="Contact page से founder के साथ paid WhatsApp chat / call की bookings"
        actions={
          <>
            <a href={siteLink("/contact#book")} target="_blank" rel="noreferrer"><Btn icon="fa-solid fa-arrow-up-right-from-square">Page देखें</Btn></a>
            <Btn icon="fa-solid fa-sliders" onClick={() => setShowSettings((v) => !v)}>Settings</Btn>
            <Btn icon="fa-solid fa-download" disabled={!items.length} onClick={() => exportCsv(items.map((a) => ({ name: a.name, email: a.email, phone: a.phone, city: a.city || "", mode: a.mode, minutes: a.minutes, amount: a.amount, topic: a.topic, details: a.details, prefDate: a.prefDate || "", prefSlot: a.prefSlot || "", utr: a.utr, status: a.status, booked: a.createdAt, scheduled: a.scheduledAt || "" })), "ycnp-appointments")}>CSV</Btn>
          </>
        } />
      {showSettings && <SettingsCard />}
      <div className="flex flex-col gap-3 mb-4">
        <Tabs tabs={TABS} value={status} onChange={setStatus} />
        <div className="flex flex-wrap items-center gap-3">
          <Search value={q} onChange={setQ} placeholder="नाम, email, phone या UTR…" className="flex-1 min-w-[220px]" />
          {data && <span className="text-sm wa-muted">{num(data.total)} bookings · {num(data.minutes)} मिनट · कुल <b className="text-[color:var(--wa-ink)]">{money(data.sum)}</b></span>}
        </div>
      </div>
      <ErrorBox msg={error} retry={reload} />
      {loading && !data ? <Skeleton rows={4} h={140} /> : !items.length ? (
        <Card><Empty icon={status === "PENDING" ? "fa-solid fa-check-double" : "fa-regular fa-calendar"} title={status === "PENDING" ? "कोई booking बाकी नहीं 🎉" : "कुछ नहीं मिला"} /></Card>
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.id} className="wa-card wa-in p-4 flex flex-wrap gap-4 items-start">
              <button type="button" onClick={() => setShot(a)} className="shrink-0 group relative" aria-label="Screenshot देखें">
                <img src={absUrl(a.screenshot)} alt="" className="w-20 h-28 object-cover rounded-xl border wa-line" />
                <span className="absolute inset-0 rounded-xl bg-black/40 opacity-0 group-hover:opacity-100 grid place-items-center text-white"><i className="fa-solid fa-magnifying-glass-plus" /></span>
              </button>
              <div className="flex-1 min-w-[260px]">
                <div className="flex flex-wrap items-center gap-2">
                  <Avatar name={a.name} size={26} />
                  <Link to={`/website/users?open=${a.userId}`} className="font-bold hover:underline">{a.name}</Link>
                  <span className="text-[12.5px] wa-muted">{a.email}</span>
                  <StatusBadge s={a.status === "DONE" ? "CLOSED" : a.status} />
                  <Badge tone={a.mode === "CALL" ? "cyan" : "green"} icon={a.mode === "CALL" ? "fa-solid fa-phone" : "fa-brands fa-whatsapp"}>{a.mode === "CALL" ? "Call" : "WhatsApp"}</Badge>
                </div>
                <div className="flex flex-wrap gap-x-5 gap-y-1 mt-2 text-sm">
                  <span><b>{a.minutes}</b> मिनट</span>
                  <span>रकम <b className="tabular-nums">{money(a.amount)}</b></span>
                  <span>UTR <b className="select-all font-mono">{a.utr}</b></span>
                  <span>📱 <b className="select-all">{a.phone}</b></span>
                  {a.city && <span>📍 {a.city}</span>}
                </div>
                <p className="text-sm mt-2"><b>{a.topic}</b></p>
                <p className="text-[13px] mt-1 whitespace-pre-line break-words p-2.5 rounded-lg" style={{ background: "color-mix(in srgb, var(--wa-ink) 5%, transparent)" }}>{a.details}</p>
                <p className="text-[12px] wa-muted mt-1.5">
                  Book {fdt(a.createdAt)} ({ago(a.createdAt)})
                  {a.prefDate || a.prefSlot ? ` · पसंद: ${a.prefDate || "कोई भी दिन"} ${a.prefSlot ? SLOT[a.prefSlot] || "" : ""}` : ""}
                  {a.scheduledAt ? ` · तय समय: ${fdt(a.scheduledAt)}` : ""}
                </p>
                {a.note && <p className="text-[12.5px] mt-1.5">📝 {a.note}</p>}
              </div>
              <div className="flex flex-wrap gap-2 sm:flex-col sm:items-stretch">
                {a.status === "PENDING" && (
                  <>
                    <Btn variant="success" icon="fa-solid fa-check" onClick={() => setApproving(a)}>Confirm</Btn>
                    <Btn variant="danger" icon="fa-solid fa-xmark" onClick={() => reject(a)}>Reject</Btn>
                  </>
                )}
                {a.status === "APPROVED" && (
                  <>
                    <a href={wa(a)} target="_blank" rel="noreferrer"><Btn variant="success" icon="fa-brands fa-whatsapp" className="w-full">WhatsApp करें</Btn></a>
                    <a href={`tel:${a.phone}`}><Btn icon="fa-solid fa-phone" className="w-full">Call करें</Btn></a>
                    <Btn size="sm" icon="fa-solid fa-flag-checkered" onClick={() => act({ id: a.id, decision: "done" }, "Booking पूरी हो गई")}>बात हो गई</Btn>
                  </>
                )}
                {(a.status === "REJECTED" || a.status === "DONE") && <Btn size="sm" icon="fa-solid fa-rotate-left" onClick={() => act({ id: a.id, decision: "reopen" }, "फिर से Pending में", { title: "इसे फिर से Pending में डालें?" })}>फिर से देखें</Btn>}
                <Btn size="sm" icon="fa-regular fa-note-sticky" onClick={async () => { const n = await prompt({ title: "Note (user को दिखेगा)", defaultValue: a.note || "" }); if (n !== null) act({ id: a.id, decision: "note", note: n }, "Note save हो गया"); }}>Note</Btn>
                <Btn size="sm" className="!text-rose-600" icon="fa-regular fa-trash-can" aria-label="Delete" onClick={() => act({ id: a.id, decision: "delete" }, "Booking delete हो गई", { title: "यह booking delete करें?", text: "सिर्फ गलत/duplicate entry के लिए।", danger: true })} />
              </div>
            </div>
          ))}
          <Pager total={data.total} take={TAKE} skip={skip} onChange={setSkip} />
        </div>
      )}
      {shot && (
        <Modal open onClose={() => setShot(null)} title={`Screenshot — UTR ${shot.utr}`} width={520}>
          <img src={absUrl(shot.screenshot)} alt="Payment screenshot" className="w-full rounded-xl" />
        </Modal>
      )}
      {approving && <ApproveModal a={approving} onClose={() => setApproving(null)} onDone={() => { setApproving(null); reload(); }} />}
    </div>
  );
}
